export const colors = {
  DARKWHITE: "#dddddd",
  WHITE: "#fff",
  BLACK: "#000",
  RED: "#ff1e1d",
  GREEN: "#49BF00",
  MAIN_COLOR: "#8A2BFF",
  MAIN_COLOR_DARK: "#3D0089",
  SECONDARY: "#8A2BFF",
  THIRDCOLOR: "#c2c9d1",
  BACKGROUND: "rgba(22,22,22,0.8)",
  GOLD: "gold",
};